export default __webpack_public_path__ + "static/media/profile_image.fd183ac6.svg";